import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import axios from 'axios';

const TextToCardModal = ({ open, onClose, onSaveSuccess, API_BASE }) => {
  const [text, setText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!text.trim()) {
      setError('Please enter some text to process.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(
        `${API_BASE}/parse-text-save-cards`,
        { raw_text: text },
        { withCredentials: true }
      );

      if (response.data.success) {
        setText('');
        onSaveSuccess();
        onClose();
      } else {
        setError(response.data.message || 'Failed to process text.');
      }
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message || 'An error occurred while processing the text.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={!isLoading ? onClose : undefined} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Convert Text to Card</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Paste raw text containing contact info (like an email signature, LinkedIn bio, or typed details). Our AI will extract the data and create a digital card automatically.
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <TextField
          autoFocus
          margin="dense"
          label="Raw Contact Information"
          type="text"
          fullWidth
          multiline
          rows={10}
          value={text}
          onChange={(e) => setText(e.target.value)}
          disabled={isLoading}
          placeholder={`John Doe\nSoftware Engineer at Tech Solutions\njohn.doe@example.com\n+1 555-0198\nwww.example.com`}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isLoading ? 'Processing with AI...' : 'Extract & Save Card'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TextToCardModal;